/**
 * Build share payloads and official “intent” URLs for X/Twitter, Facebook, and LinkedIn.
 * Opens in a new tab from a user gesture (avoids most popup blockers).
 */

export function buildSiteSharePayload(origin) {
  const base = (origin || '').replace(/\/$/, '') || '';
  const url = `${base}/`;
  return {
    url,
    title: 'Fortitude IT Solutions',
    text: 'Explore our portfolio, services, and IT solutions.',
  };
}

export function buildPortfolioSharePayload(origin, { projectName, projectUrl }) {
  const base = (origin || '').replace(/\/$/, '') || '';
  const u = (projectUrl || '').trim();
  const url =
    u && /^https?:\/\//i.test(u) && u !== '#'
      ? u
      : `${base}/portfolio`;
  const name = projectName || 'Our project';
  return {
    url,
    title: `${name} — Fortitude IT`,
    text: `We're proud of our work: ${name}. Discover more with Fortitude IT Solutions.`,
  };
}

/**
 * @param {'twitter'|'linkedin'|'facebook'} platformId
 * @param {{ url: string, text: string, title: string }} payload
 * @returns {string|null}
 */
export function getSocialShareUrl(platformId, payload) {
  const { url, text, title } = payload;
  if (!url) return null;

  const enc = encodeURIComponent;

  switch (platformId) {
    case 'twitter':
      return `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(url)}`;
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`;
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${enc(url)}`;
    default:
      return null;
  }
}

/**
 * @param {string[]} platformIds
 * @param {{ url: string, text: string, title: string }} payload
 * @returns {{ opened: number, attempted: number }}
 */
export function openSocialShareWindows(platformIds, payload) {
  if (typeof window === 'undefined') return { opened: 0, attempted: 0 };
  let opened = 0;
  let attempted = 0;
  for (const id of platformIds) {
    const href = getSocialShareUrl(id, payload);
    if (href) {
      attempted += 1;
      const w = window.open(href, '_blank', 'noopener,noreferrer');
      if (w) opened += 1;
    }
  }
  return { opened, attempted };
}
